export const ActionTypes = {
  CONNECT: "CONNECT",
};
